import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  host: { class: 'list' },
})
export class ListComponent {
  @Input() dense = false;
  @Input() dividers = false;

  get ngClass() {
    return {
      dense: this.dense,
      'has-dividers': this.dividers,
    };
  }
}
